import "./hierarchyModal.less";

import { IComponentOptions, material } from "angular";

import { HIERARCHY_SERVICE, HierarchyService, ModalCaller } from "../hierarchy-service/hierarchy.service";
import { AbstractHierarchySidenav } from "../hierarchy-support/abstractHierarchySidenav";
import { Constant } from "../common/utils/constants";
import { IExploringElement, ICapsuleFolder } from "../../typings/board/Models";

export const HIERARCHY_MODAL_COMPONENT: string = "hierarchyModalComponent";

class HierarchyModalController extends AbstractHierarchySidenav {
    private modalCaller: ModalCaller;
    protected expandedFolderPaths : string[];
    protected exploringData: IExploringElement[];
    private selectedCapsuleFolder : ICapsuleFolder;

    static $inject = [HIERARCHY_SERVICE, "$mdToast", "$mdDialog"];
    constructor(protected hierarchyService: HierarchyService,
        protected $mdToast: ng.material.IToastService, protected $mdDialog: ng.material.IDialogService) {
        super(hierarchyService, $mdToast, $mdDialog);
        this.selectedCapsuleFolder = null;

        this.hierarchyService.modalCaller.subscribe(res => {
            this.modalCaller = res;
            this.exploringData.forEach(el => el.isSelected = false);
            this.exploringData.forEach(el => { if (el.parent.relativePath !== "" ) { el.isVisible = false; }});
        });
    }

    protected navigateFolder(selectedCapsule: IExploringElement): void {
        this.exploringData.forEach(el => el.isSelected = false);
        selectedCapsule.isSelected = true;
        this.selectedCapsuleFolder = selectedCapsule.originCapsule;
        if (selectedCapsule.originCapsule.subFolders) {
            this.expandCollapseFolderCascade(selectedCapsule.originCapsule.relativePath, null);
        }
    }

    private overridingQuestionDialog: material.IConfirmDialog = this.$mdDialog.confirm()
        .title("File already exists!")
        .textContent("The file you are trying to upload already exists. Would you like to overwrite it?")
        .ok(Constant.YES) 
        .cancel(Constant.NO);

    private operationCompleted(message: string): void {
        this.hierarchyService.showToast(message === ""? Constant.SUCCESS: message);
        this.hierarchyService.stoppingAsyncOperation();
    }

    private submit():void {
        if ((!this.selectedCapsuleFolder) || this.selectedCapsuleFolder.name === "") {
            this.hierarchyService.showToast("Please select a valid destination");
        } else if (this.modalCaller != null) {
            if (this.modalCaller === ModalCaller.DUPLICATE) {
                this.submitDuplicate();
            } else if (this.modalCaller === ModalCaller.MOVE) {
                this.submitMove();
            }
        }
        this.selectedCapsuleFolder = null;
    }

    private submitMove (): void {
        this.hierarchyService.showHideModal();
        var _self_ : HierarchyModalController = this;
        var destinationSelectedPath : string = this.selectedCapsuleFolder.relativePath;
            this.hierarchyService.$moveCapsule(destinationSelectedPath)
            .subscribe(
            result => _self_.operationCompleted(Constant.$SUCCESS),
            err => {
            if (err.status === 409) {
                _self_.$mdDialog.show(_self_.overridingQuestionDialog).then(function (): void {
                        _self_.hierarchyService.$moveCapsule(destinationSelectedPath, true)
                            .subscribe(
                            (result) => _self_.operationCompleted(Constant.$SUCCESS),
                            (error) => _self_.operationCompleted(error.data.message));
                        }, function (): void {
                    _self_.hierarchyService.$moveCapsule(destinationSelectedPath, false)
                    .subscribe(
                        (result) => _self_.operationCompleted(Constant.$SUCCESS),
                        (error) => _self_.operationCompleted(error.data.message));
                    });
            }
        });
    }

    private abort ():void {
        this.selectedCapsuleFolder = null;
        this.hierarchyService.showHideModal();
    }
    private submitDuplicate (): void {
        this.hierarchyService.showHideModal();
        var _self_ : HierarchyModalController = this;
        var destinationSelectedPath : string = this.selectedCapsuleFolder.relativePath;
        this.hierarchyService.$duplicateCapsule(destinationSelectedPath).subscribe(
        result => _self_.operationCompleted(Constant.$SUCCESS),
        err => {
            if (err.status === 409) {
                _self_.$mdDialog.show(this.overridingQuestionDialog).then(function (): void {
                    _self_.hierarchyService.$duplicateCapsule(destinationSelectedPath, true)
                        .subscribe((result) => _self_.operationCompleted(Constant.$SUCCESS),
                                    (error) => _self_.operationCompleted(error.data.message));
                }, function (): void {
                    _self_.hierarchyService.$duplicateCapsule(destinationSelectedPath, false)
                    .subscribe((result) => _self_.operationCompleted(Constant.$SUCCESS),
                                (error) => _self_.operationCompleted(error.data.message));
                });
            }
        });
    }
}

export const hierarchyModalComponent: IComponentOptions = {
    controller: HierarchyModalController,
    template: require("./hierarchyModal.html"),
    bindings: {},
};


// WEBPACK FOOTER //
// ./app/hierarchy-modal/hierachyModal.component.ts